import { render, staticRenderFns } from "./CRTabs.vue?vue&type=template&id=4d16ddc5&scoped=true"
import script from "./CRTabs.vue?vue&type=script&lang=js"
export * from "./CRTabs.vue?vue&type=script&lang=js"
import style0 from "./CRTabs.vue?vue&type=style&index=0&id=4d16ddc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16ddc5",
  null
  
)

export default component.exports